const breadCrumb = "Rendimento - Parametrização";

const routes = [
  {
    path: "/cadastro-de-indicadores-de-rendimento",
    name: "cadastro_de_indicadores_de_rendimento",
    meta: {
      allowedPermissions: ["indicador_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CadastroDeIndicadoresDeRendimento/CadastroDeIndicadoresDeRendimentoHome.vue"
      ),
  },
  {
    path: "/cadastro-de-indicadores-de-rendimento/novo",
    name: "cadastro_de_indicadores_de_rendimento_cad",
    meta: {
      allowedPermissions: ["indicador_insert", "indicador_create"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CadastroDeIndicadoresDeRendimento/CadastroDeIndicadoresDeRendimentoCad.vue"
      ),
  },
  {
    path: "/cadastro-de-indicadores-de-rendimento/edit/:id",
    name: "cadastro_de_indicadores_de_rendimento_edit",
    meta: {
      allowedPermissions: [
        "indicador_show",
        "indicador_update",
        "indicador_edit",
      ],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CadastroDeIndicadoresDeRendimento/CadastroDeIndicadoresDeRendimentoEdit.vue"
      ),
  },
  {
    path: "/cadastro-de-indicadores-de-rendimento/visualizar/:id",
    name: "cadastro_de_indicadores_de_rendimento_visualizar",
    meta: {
      allowedPermissions: ["indicador_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CadastroDeIndicadoresDeRendimento/CadastroDeIndicadoresDeRendimentoVisualizar.vue"
      ),
  },
];

export default routes;
